import { GridColDef, getGridStringOperators } from "@mui/x-data-grid-pro";

function useIdColumn(): GridColDef {
  return {
    display: "flex",
    headerName: "Id",
    field: "id",
    flex: 1,
    filterOperators: getGridStringOperators(true)
      .filter((op) => op.value === "equals")
      .map((op) => ({ ...op, value: "is" })),
  };
}
export default useIdColumn;
